export default "__VITE_ASSET__D78cf$BL__"